import { useCallback } from "react";

import SuggestedPencilIcon from "@assets/icons/suggestion-pencil.svg";

import { OptionsForTags, Tag } from "@interfaces/tag.interface";
import { ITagResponse } from "@interfaces/responses.interface";
import { SUGGESTED_TAG_GROUPS } from "@components/Sections/TagsSection/constants";
import { SuggestedItemWrapper } from "../../TaggingComponent/SuggestionItems/SuggestedItemWrapper";
import { SuggestionItem } from "../../TaggingComponent/SuggestionItems/SuggestionItem";

interface Props {
  title: string;
  suggestedTaggingOptions: OptionsForTags;
  onAddTags: (value: Tag[]) => void;
}

export function SuggestedTags({ title, suggestedTaggingOptions, onAddTags }: Props) {
  const renderTags = useCallback(
    (data: OptionsForTags, onChange: (value: ITagResponse) => void) => {
      return SUGGESTED_TAG_GROUPS.flatMap((key) =>
        (data[key] || []).map((item) => (
          <SuggestedItemWrapper key={item.id} item={item} isMember={false} onSubmit={onChange}>
            <SuggestionItem item={item} group={key} style={{ padding: 0 }} />
          </SuggestedItemWrapper>
        ))
      );
    },
    []
  );

  const onSelect = (item: ITagResponse) => {
    const newValue = [item] as unknown;

    onAddTags(newValue as Tag[]);
  };

  const noTaggingOptions = Object.values(suggestedTaggingOptions || {}).every(
    (arr) => arr.length === 0
  );

  if (noTaggingOptions) return null;

  return (
    <section className="text-[black]dark:text-white flex flex-col gap-2 border-t dark:border-gray-600 pt-4 my-4">
      <div className="flex items-center gap-2">
        <SuggestedPencilIcon className="text-sky-600 scale-[110%]" />
        <p className="text-xs text-gray-950 dark:text-invertedPrimary80 font-[400]">{title}</p>
      </div>

      <div className="relative flex flex-wrap items-center gap-1 px-1">
        {renderTags(suggestedTaggingOptions, onSelect)}
      </div>
    </section>
  );
}
